import React from 'react';
import {FieldRenderProps} from 'react-final-form-hooks';
import {Button, TextField, Typography} from '@material-ui/core';
import AccountStatusSelector from '@pluto/account-status';

interface ContentPartnerProps {
    cmsPartnerIdField: FieldRenderProps;
    statusField: FieldRenderProps;
    createdField: FieldRenderProps;
    updatedField: FieldRenderProps;
    partnerNameField: FieldRenderProps;
    onSaveHandler: () => void;
    onPushRouteToHistory: () => void;
    valid: boolean;
    isEditMode: boolean;
}

export const isActiveStatus = (active: boolean | string) =>
    active && active !== 'INACTIVE' ? 'ACTIVE' : 'INACTIVE';

export default function ContentPartner(props: ContentPartnerProps) {
    const {
        partnerNameField,
        cmsPartnerIdField,
        onSaveHandler,
        onPushRouteToHistory,
        valid,
        statusField,
        createdField,
        updatedField,
        isEditMode,
    } = props;

    const {
        input: inputProps,
        meta: {touched: nameTouched, error: nameErrorMessage},
    } = partnerNameField;

    const nameError = nameTouched && nameErrorMessage;

    const {
        input: idProps,
        meta: {touched: idTouched, error: idErrorMessage},
    } = cmsPartnerIdField;

    const idError = idTouched && idErrorMessage;

    return (
        <div className="content-partner-form">
            <div className="content-partner-form__field content-partner-form__field_big">
                <div className="content-partner-form__field-label content-partner-form__field-label_url">
                    Partner Name *
                </div>
                <TextField
                    {...inputProps}
                    error={Boolean(nameError)}
                    placeholder="Partner Name"
                    variant="outlined"
                    helperText={nameError}
                />
            </div>
            <div className="content-partner-form__field content-partner-form__field_big">
                <div className="content-partner-form__field-label content-partner-form__field-label_url">
                    Partner ID *
                </div>
                <TextField
                    {...idProps}
                    error={Boolean(idError)}
                    placeholder="Partner ID"
                    variant="outlined"
                    helperText={idError}
                />
            </div>
            {isEditMode && (
                <>
                    <div className="content-partner-form__field content-partner-form__field_big">
                        <div className="content-partner-form__field-label content-partner-form__field-label_url">
                            Created Date
                        </div>
                        <Typography variant="subtitle2" component="span">
                            {createdField.input.value}
                        </Typography>
                    </div>
                    <div className="content-partner-form__field content-partner-form__field_big">
                        <div className="content-partner-form__field-label content-partner-form__field-label_url">
                            Updated Date
                        </div>
                        <Typography variant="subtitle2" component="span">
                            {updatedField.input.value}
                        </Typography>
                    </div>
                    <div className="content-partner-form__status-wrapper">
                        <div className="content-partner-form__field content-partner-form__field_small">
                            <div className="content-partner-form__field-label content-partner-form__field-label_status">
                                Status
                            </div>
                            <AccountStatusSelector
                                onChange={statusField.input.onChange}
                                value={isActiveStatus(statusField.input.value)}
                                variant="outlined"
                            />
                        </div>
                    </div>
                </>
            )}
            <div className="content-partner-form__controls-buttons-wrapper">
                <Button
                    disabled={!valid}
                    className="content-partner-form__control-button content-partner-form__control-button_save"
                    variant="contained"
                    onClick={onSaveHandler}
                >
                    Save
                </Button>
                <Button
                    className="content-partner-form__control-button content-partner-form__control-button_cancel"
                    variant="contained"
                    onClick={onPushRouteToHistory}
                >
                    Cancel
                </Button>
            </div>
        </div>
    );
}
